// Compose a single display string from the user's name model
// (wiki/feature-user-profile.md AC-UP-1). The user's name is a single optional
// `name`; the display string falls back to the email's local part, then to a
// generic placeholder.

export type NameParts = {
  name?: string | null;
  email?: string | null;
};

/**
 * Returns the trimmed `name` when present, otherwise the email's local part,
 * otherwise the supplied fallback (default `'—'`).
 */
export function displayName(parts: NameParts, fallback = '—'): string {
  const composed = parts.name?.trim();
  if (composed) {
    return composed;
  }

  const local = parts.email?.split('@')[0]?.trim();
  return local || fallback;
}
